module.exports = __webpack_public_path__ + "img/ico_new_3.d9a63539.svg";